var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 11C10.6642 11 11 10.6642 11 10.25V4.75C11 4.33579 11.3358 4 11.75 4H12.25C12.6642 4 13 4.33579 13 4.75V10.25C13 10.6642 13.3358 11 13.75 11H19.25C19.6642 11 20 11.3358 20 11.75V12.25C20 12.6642 19.6642 13 19.25 13H13.75C13.3358 13 13 13.3358 13 13.75V19.25C13 19.6642 12.6642 20 12.25 20H11.75C11.3358 20 11 19.6642 11 19.25V13.75C11 13.3358 10.6642 13 10.25 13H4.75C4.33579 13 4 12.6642 4 12.25V11.75C4 11.3358 4.33579 11 4.75 11H10.25Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconadd);
export default __webpack_public_path__ + "static/media/icon.add.ff7a200b1a61c52bfb4caa33a1f33a46.svg";
export { ForwardRef as ReactComponent };